import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';

import SignedDocument from 'SharedComponents/Signature/SignedDocument.vue';
import { useFieldFileSigning } from 'SharedDir/common/composables/useFieldFileSigning';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FieldFileSigningActions' },
  __name: 'FieldFileSigningActions',
  props: {
    fileId: {},
    fileName: {}
  },
  setup(__props: any) {



const props = __props;

const fileId = computed(() => props.fileId);
const fileName = computed(() => props.fileName);

const {
  signature,
  signers,
  loading,
  showSigningUi,
  allowSigning,
  canExportSignature,
  documentInfo,
  saveSignature,
} = useFieldFileSigning({
  fileId,
  fileName,
});

return (_ctx: any,_cache: any) => {
  return (_unref(showSigningUi))
    ? (_openBlock(), _createBlock(SignedDocument, {
        key: 0,
        modelValue: _unref(signature),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(signature) ? (signature).value = $event : null)),
        compact: "",
        document: _unref(documentInfo),
        "allow-signing": _unref(allowSigning),
        "allow-download-signature": _unref(canExportSignature),
        signers: _unref(signers),
        loading: _unref(loading),
        "onUpdate:signers": _cache[1] || (_cache[1] = ($event: any) => (signers.value = $event)),
        onSigned: _unref(saveSignature)
      }, null, 8, ["modelValue", "document", "allow-signing", "allow-download-signature", "signers", "loading", "onSigned"]))
    : _createCommentVNode("", true)
}
}

})